import axios from "axios";
import {API_URL} from "../../redux/actions/action.constance";
import createAuthRefreshInterceptor from 'axios-auth-refresh';

const instance = axios.create({
  baseURL: API_URL
});


export const setAccessToken = token => {
  instance.defaults.headers.common.Authorization = `Bearer ${token}`;
};

export const unsetAccessToken = token => {
  delete instance.defaults.headers.common.Authorization
};

const refreshAuthLogic = failedRequest =>
  instance.post(`v1/admin/refresh`,
    {
      refreshToken: localStorage.getItem('refreshToken')
    },
    {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "cache-control": "no-cache",
        Authorization: `Bearer ${localStorage.getItem('apiToken')}`,
      }
    }).then(tokenRefreshResponse => {
    const accessToken = tokenRefreshResponse.data.token;
    const refreshToken = tokenRefreshResponse.data.refreshToken;

    localStorage.setItem('apiToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken);

    setAccessToken(accessToken);

    failedRequest.response.config.headers.Authorization = `Bearer ${accessToken}`
    return Promise.resolve()
  }).catch(e => {

      if (e.message === "Request failed with status code 401") {
        unsetAccessToken(localStorage.getItem('apiToken'));
        localStorage.clear()
        window.location.replace("/login");
      }
    }
  )

export default createAuthRefreshInterceptor(instance, refreshAuthLogic)
